import HomePage         from './pages/landings/home/home';
import RegisterPage     from './pages/user/register/register';
import PlayerPage       from './pages/player/player';
import MovieDetailPage  from './pages/movie/detail/movie-detail';
import VerifyPage       from './pages/user/verify/verify';
import CredentialPage   from './pages/user/credential/credential';
import AuthenticatePage from './pages/user/authenticate/authenticate';
import ProfilePage      from './pages/user/profile/profile';
import SeriesDetailPage from './pages/series/detail/series-detail';
import SeriesListPage   from './pages/series/list/series-list';
import EditProfilePage  from './pages/user/profile/edit/edit-profile';
import SearchPage      from './pages/search/search';
import ProgramMorePage from './pages/more-pages/program-more-page';
import TagMorePage     from './pages/more-pages/tag-more-page';
import SearchMorePage  from './pages/more-pages/search-more-page';
import InvoicePage     from './pages/user/invoice/invoice';
import FavListPage     from './pages/user/fav-list/fav-list';
import Purchases       from './pages/user/purchases/purchases';
import NotFound        from './pages/statics/404/not-found';
import NotAuthorized   from './pages/statics/403/not-authorized';
import ServerError     from './pages/statics/500/server-error';
import PurchaseDetails from './pages/user/purchases/purchase-details/purchase-details';
import SessionsPage    from './pages/user/sessions/sessions';
import Terms    from './pages/terms/terms';
import CategoryPage    from './pages/category/category';
import Faq from './pages/faq/faq';
import ContactUs from './pages/contact-us/contact-us';
import BazaarDetailProgram from './pages/cafebazaar/detail-program/detail-program';
import Dmca from './pages/dmca/dmca';

const routes = [
	{
		path     : '/',
		component: HomePage,
		exact    : true,
		title: 'خانه'
	},
	{
		path     : '/register',
		component: RegisterPage,
		exact    : true,
		title: 'ثبت‌نام'
	},
	{
		path     : '/verify',
		component: VerifyPage,
		exact    : true,
		title: 'تایید هویت'
	},
	{
		path     : '/credential',
		component: CredentialPage,
		exact    : true,
		title: 'احراز هویت'
	},
	{
		path     : '/authenticate',
		component: AuthenticatePage,
		exact    : true,
		title: 'احراز هویت'
	},
	{
		path     : '/profile',
		component: ProfilePage,
		exact    : true,
		title: 'پروفایل'
	},
	{
		path     : '/profile/edit',
		component: EditProfilePage,
		exact    : true,
		title: 'ویرایش پروفایل'
	},
	{
		path     : '/player/:id',
		component: PlayerPage,
		exact    : true,
		externalStyle: true,
		title: 'پخش برنامه'
	},
	{
		path     : '/movies/:id',
		component: MovieDetailPage,
		exact    : true,
		title: 'فیلم'
	},
	{
		path     : '/series',
		component: SeriesListPage,
		exact    : true,
		title: 'سریال‌ها'
	},
	{
		path     : '/series/:id',
		component: SeriesDetailPage,
		exact    : true,
		title: 'سریال'
	},
	{
		path     : '/series/:id/:season/:episode',
		component: SeriesDetailPage,
		exact    : true,
		title: 'سریال'
	},
	{
		path     : '/p/:type/:id',
		component: ProgramMorePage,
		exact    : true,
		title: 'جزئیات برنامه'
	},
	{
		path     : '/p/:type/:id/:option',
		component: ProgramMorePage,
		exact    : true,
		title: 'جزئیات بیشتر برنامه'
	},
	{
		path     : '/t/:tagDef/:id',
		component: TagMorePage,
		exact    : true,
		title: 'برچسب'
	},
	{
		path     : '/t/:tagDef/:id/:type',
		component: TagMorePage,
		exact    : true,
		title: 'جزئیات برچسب'
	},
	{
		path     : '/search',
		component: SearchPage,
		exact    : true,
		title: 'جستجو'
	},
	{
		path     : '/search/:text',
		component: SearchPage,
		exact    : true,
		title: 'نتایج جستجو'
	},
	{
		path     : '/search/:text/:type',
		component: SearchMorePage,
		exact    : true,
		title: 'جزئیات جستجو'
	},
	{
		path     : '/invoice/:refId',
		component: InvoicePage,
		exact    : true,
		title: 'صورت‌حساب'
	},
	{
		path     : '/fav-list',
		component: FavListPage,
		exact    : true,
		title: 'لیست علاقه‌مندی‌ها'
	},
	{
		path     : '/category',
		component: CategoryPage,
		exact    : true,
		title: 'دسته‌بندی‌ها'
	},
	{
		path     : '/genre',
		component: CategoryPage,
		exact    : true,
		title: 'ژانر‌ها'
	},
	{
		path     : '/purchases',
		component: Purchases,
		exact    : true,
		title: 'خریدها'
	},
	{
		path     : '/purchases/:id',
		component: PurchaseDetails,
		exact    : true,
		title: 'جزئیات خرید'
	},
	{
		path     : '/sessions',
		component: SessionsPage,
		exact    : true,
		title: 'نشست‌ها'
	},
	{
		path     : '/terms',
		component: Terms,
		exact    : true,
		title: 'قوانین'
	},
	{
		path     : '/faq',
		component: Faq,
		exact    : true,
		title: 'سوالات متداول'
	},
	{
		path     : '/cafebazaar/:type/:id',
		component: BazaarDetailProgram,
		exact    : true,
		externalStyle: true // Adding this field to specify that this route should use a custom/external style and layout
	},
	{
		path     : '/contact-us',
		component: ContactUs,
		exact    : true,
		title: 'تماس با ما'
	},
	{
		path     : '/dmca',
		component: Dmca,
		exact    : true,
		title: 'DMCA'
	},
	{
		path     : '/403',
		component: NotAuthorized,
		exact    : true,
		title: 'دسترسی غیرمجاز'
	},
	{
		path     : '/404',
		component: NotFound,
		exact    : true,
		title: 'صفحه 404'
	},
	{
		path     : '/500',
		component: ServerError,
		exact    : true,
		title: 'خطای سرور'
	}
];
export default routes;
